import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { finalize } from 'rxjs';
import { apiErrorFallback, extractApiErrorMessage } from '../../../../../core/http/extract-api-error-message';
import { Translation } from '../../../../../core/i18n/translation.service';
import { AssetChargesService } from '../../../../../core/services/asset-charges.service';
import { BenefitsDialogComponent } from '../../benefits/shared/dialogs/benefits-dialog/benefits-dialog.component';
import { AssetSelectComponent } from '../asset-select/asset-select.component';

/** Links a purchase charge to an asset. */
@Component({
  selector: 'app-link-asset-dialog',
  standalone: true,
  imports: [TranslatePipe, ButtonModule, BenefitsDialogComponent, AssetSelectComponent],
  templateUrl: './link-asset-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkAssetDialogComponent {
  private readonly charges = inject(AssetChargesService);
  private readonly translation = inject(Translation);

  readonly chargeId = input.required<string>();
  readonly linked = output<void>();
  readonly closed = output<void>();

  protected readonly assetId = signal('');
  protected readonly saving = signal(false);
  protected readonly error = signal<string | null>(null);
  protected readonly valid = computed(() => !!this.assetId());

  protected confirm(): void {
    if (!this.valid() || this.saving()) return;
    this.saving.set(true);
    this.error.set(null);
    this.charges
      .linkAsset(this.chargeId(), this.assetId())
      .pipe(finalize(() => this.saving.set(false)))
      .subscribe({
        next: () => this.linked.emit(),
        error: (err) => this.error.set(extractApiErrorMessage(err, apiErrorFallback(this.translation))),
      });
  }
}
